<div class="view-component">
    <div class="view-component-title">
        <span class="title">Fluxo de Produtos</span>
    </div>

    <div class="maindiv-notab">
        <simple-datagrid entityName='Mktpskus' parentRow=""  [condition]="codition" [nodata]="nodata" ></simple-datagrid>
        
    </div>
    
</div>